/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-26 17:09:28
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-06-23 16:04:02
 * @FilePath: \crm-product\src\views\performanceCalculation\views\result_statement\annual_terminal_performance_report\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import TablePage from '@/found/components/table_page';
import DetailForm from '../form/detail.vue';
import Form from '../form/allocationForm.js';

export default {
  extends: TablePage,
  components: {
    Form,
    DetailForm,
  },
  name: 'DealerPerformanceReportTable',
  data() {
    return {

    };
  },
  created() {
    this.getConfigList('main-list');
  },

  methods: {
    modalClick({ val, row }) {
      if (val.code === 'detail') {
        this.formConfig = {
          mainId: row.id,
        };
        this.formName = 'DetailForm';
        this.modalConfig.title = '发货明细';
        this.openFull();
      } else if (val.code === 'allocation') {
        this.formConfig = {
          ...val,
          row,
        };
        this.formName = 'Form';
        this.modalConfig.title = '分配业绩';
        this.openFull();
      }
    },
  },
};
